import { ILogContext } from './log-context.interface';
import { LogLevel } from './log-level.enum';
import { ILogTrackingInfo } from './log-tracking-info.interface';


/**
 * Describes a log handler instance.
 *
 * NOTE: These handlers use Promises instead of RxJS Observables in order to reduce the size of stack traces.
 */
export interface ILogHandler {
  /**
   * The service name, to be used when displaying the service status information.
   */
  readonly name: string;

  /**
   * A status flag to indicate if the the service is in use.
   */
  readonly enabled: boolean;

  /**
   * Returns the log handler status information, containing possible errors and warning messages.
   */
  getStatus(): Promise<ILogHandlerStatus>;

  /**
   * Logs a message with an arbitrary level and returns a promise containing a list of tracking information, if any.
   *
   * NOTE: All log handler implementations should handle possible runtime errors.
   */
  handle(level: LogLevel, message: string, context?: ILogContext): Promise<ILogTrackingInfo | null>;
}

export interface ILogHandlerStatus extends Record<string, boolean | number | string | undefined> {
  handlerName: string;
}
